<template>
  <ReviewOfPacking ref="ReviewOfPacking" />
</template>
<script>
  import ReviewOfPacking from "@/pdaView/outbound/packing/ReviewOfPacking.vue"

  export default {
    components: { ReviewOfPacking },
    data() {
      return {
        device: true
      }
    },
    props: {
      queryParam: {
        type: Object,
        default: null
      }
    }
  }
</script>